import * as React from 'react';
import { useAccountTwrrEndDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountsTwrrTAccTwrrPEndDate = (props: {
  format?: string,
}) => {
  const {
    format,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useAccountTwrrEndDate();
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={format}
    />
  );
};
